import { render, staticRenderFns } from "./manage-lookup.vue?vue&type=template&id=dc93b00c&"
import script from "./manage-lookup.vue?vue&type=script&lang=js&"
export * from "./manage-lookup.vue?vue&type=script&lang=js&"
import style0 from "./manage-lookup.vue?vue&type=style&index=0&id=dc93b00c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports